.output {
  display: inline-block;
  background: #0099211a;
  color: #009921;
  padding: 5px 15px;
  text-align: center;
  border-radius: 8px;;
}